import { BlockUI, NgBlockUI }           from 'ng-block-ui';
import { ChangeDetectorRef, Component } from '@angular/core';
import { NgbActiveModal }               from '@ng-bootstrap/ng-bootstrap';

import { ApiService }        from '../api/api.service';
import { FlipperSidesModel } from '../shared/components/flipper/typings/flipper.sides';
import { MessagesService }   from '../messages/messages.service';
import { SessionService }    from '../sessions/session.service';

@Component({
  selector   : 'wor-sync-xero',
  template: require('./xero.sync.component.html')
})
export class SyncXeroComponent {
  public activeSide : FlipperSidesModel = 'front';
  public email      : string            = this.sessionService.company().admin_email;
  public uploading  : boolean           = false;

  @BlockUI('syncXeroBlock') block : NgBlockUI;

  constructor (
    public activeModal       : NgbActiveModal,
    private apiService       : ApiService,
    private changeDetectorRef: ChangeDetectorRef,
    private messagesService  : MessagesService,
    private sessionService   : SessionService
  ) {}

  download () {
    let conflicts : any;

    this.block.start();

    this.apiService.get('/xero/contact_download')
    .then(( response : any ) => {
      conflicts = response;

      return this.sessionService.refresh();
    })
    .then(() => {
      this.activeModal.close(conflicts);
    })
    .catch(err => {
      this.messagesService.error(err);

      this.activeModal.dismiss();
    })
    .finally(() => {
      this.block.stop();
    });
  }

  flip ( side : FlipperSidesModel = 'back' ) : void {
    this.activeSide = side;

    this.changeDetectorRef.detectChanges();
  }

  upload () : void {
    this.uploading = true;

    this.apiService.post('xero/upload', { email: this.email })
    .then(() => {
      this.flip();

      this.download();
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.uploading = false;
    });
  }
}
